module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$l('archives/audioPopOver/downlRec') + ' - ' + _vm.data.name,
      "visible": _vm.data.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.data, "visible", $event)
      }
    }
  }, [_c('el-form', [_c('el-row', [_c('el-col', {
    staticClass: "range-title",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$l('archives/audioPopOver/range')) + "\n            ")]), _vm._v(" "), _c('el-col', {
    staticClass: "range-value",
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                0 s\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-slider', {
    attrs: {
      "range": "",
      "show-stops": "",
      "max": _vm.data.length
    },
    model: {
      value: (_vm.data.selection),
      callback: function($$v) {
        _vm.$set(_vm.data, "selection", $$v)
      },
      expression: "data.selection"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "range-value",
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                " + _vm._s(_vm.data.length) + " s\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Download')) + "  ")]), _vm._v(" "), _c('el-button', {
    staticClass: "close-button",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.data.visible = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Close')) + "  ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-711f737d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archives/AudioDownloadDialog.vue
// module id = 467
// module chunks = 1